// src/HorecaHubMetaverseLanding.jsx
import React, { useState } from "react";
import HorecaHubMetaverseHeroSection from "./components/HorecaHubMetaverseHeroSection";
import HorecaHubMetaverseStakeholdersGrid from "./components/HorecaHubMetaverseStakeholdersGrid";
import HorecaHubMetaverseMarketplace from "./components/HorecaHubMetaverseMarketplace";
import HorecaHubMetaverseStagedTimeline from "./components/HorecaHubMetaverseStagedTimeline";
import HorecaHubMetaverseAnimatedUniverse from "./components/HorecaHubMetaverseAnimatedUniverse";
import HorecaHubMetaverseMap from "./components/HorecaHubMetaverseMap";

const HorecaHubMetaverseLanding = () => {
  // Dummy "player"
  const [player] = useState({ id: "player1", name: "You" });

  // Dummy marketplace dataset (you’ll replace with real listings later)
  // const [selectedListings, setSelectedListings] = useState([
  //   { id: 1, type: "crop", name: "Tomato", owner: "player1" },
  //   { id: 2, type: "crop", name: "Potato", owner: "resident1" },
  //   { id: 3, type: "item", name: "Tractor", owner: "resident2" },
  //   { id: 4, type: "crop", name: "Wheat", owner: null },
  //   { id: 5, type: "facility", name: "Warehouse", owner: "resident3" },
  // ]);

  const [selectedListings, setSelectedListings] = useState([
  {
      id: 1,
      name: "Elco Pani Puri",
      vendor: "vendor1",
      dish: "Pani Puri",
      priceRange: "₹60-80 / plate",
      rating: 4.8,
      reviews: 1345,
      offer: true,
      verified: true,
      img: "https://images.unsplash.com/photo-1606491956689-2ea866880c84?auto=format&fit=crop&w=800&q=80",
      location: "Chaat Corner",
      coords: { r: 0, c: 0 },
    },
    {
      id: 2,
      name: "Ashok Vada Pav",
      vendor: "vendor2",
      dish: "Vada Pav",
      priceRange: "₹30-50",
      rating: 4.8,
      reviews: 1800,
      offer: false,
      verified: true,
      img: "https://images.unsplash.com/photo-1629531733455-3c5e3be1a8a8?auto=format&fit=crop&w=800&q=80",
      location: "Main Street",
      coords: { r: 1, c: 2 },
    },
    {
      id: 3,
      name: "Sardar Pav Bhaji",
      vendor: null, // available
      dish: "Pav Bhaji",
      priceRange: "₹150-200 / plate",
      rating: 4.9,
      reviews: 2500,
      offer: false,
      verified: true,
      img: "https://images.unsplash.com/photo-1631451095765-6c7be420e92b?auto=format&fit=crop&w=800&q=80",
      location: "Central Zone",
      coords: { r: 3, c: 4 },
    },
    {
      id: 4,
      name: "Dolma Aunty Momos",
      vendor: "vendor3",
      dish: "Momos",
      priceRange: "₹100-150 / plate",
      rating: 4.9,
      reviews: 2100,
      offer: true,
      verified: true,
      img: "https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=800&q=80",
      location: "Indo-Chinese Lane",
      coords: { r: 2, c: 6 },
    },
    {
      id: 5,
      name: "Lucky Biryani Corner",
      vendor: "vendor4",
      dish: "Chicken Biryani",
      priceRange: "₹250-350 / plate",
      rating: 4.7,
      reviews: 1200,
      offer: true,
      verified: false,
      img: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?auto=format&fit=crop&w=800&q=80",
      location: "Non-Veg Zone",
      coords: { r: 4, c: 1 },
    },
  ]);

  // Example handlers
  const handleContact = (listing) => {
    alert(`Contacting owner of ${listing.name}`);
  };

  const handleMakeOffer = (listing, amount) => {
    alert(`Making offer of ₹${amount} for ${listing.name}`);
  };

  return (
    <div className="min-h-screen bg-black px-4 py-6">
      <HorecaHubMetaverseHeroSection />
      <HorecaHubMetaverseAnimatedUniverse />

      {/* Marketplace */}
      <HorecaHubMetaverseMarketplace onSelect={setSelectedListings} />

      {/* Khau Gali  Map */}
      <HorecaHubMetaverseMap
        rows={6}
        cols={8}
        dataset={selectedListings}
        ownerId={player.id}
        onContact={handleContact}
        onMakeOffer={handleMakeOffer}
      />

      <HorecaHubMetaverseStagedTimeline />

      {/* CTA */}
      <div className="text-center mt-12">
        <button className="bg-green-700 text-white px-6 py-3 rounded-2xl text-lg font-semibold shadow-lg hover:bg-green-800 transition">
          Join Now
        </button>
      </div>
    </div>
  );
};

export default HorecaHubMetaverseLanding;
